/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Act_AssignInputs */

const vi_cdo_act_assign = /** @type {(inputs: Cdo_Act_AssignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gán tài xế`)
};

/**

* @param {Cdo_Act_AssignInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_act_assign = /** @type {((inputs?: Cdo_Act_AssignInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Act_AssignInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_act_assign(inputs)
});